import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  useEffect(() => {
    // Google Tag Manager (gtag.js)
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=AW-17810960450';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-17810960450');
    `;
    document.head.appendChild(script2);
    // Set page title
    document.title = 'Activa tu Energía Femenina | Alma en Expansión - Programa de 21 Días';
    // Set SEO and Open Graph meta tags
    const metaTags = [
    // Primary SEO
    {
      name: 'description',
      content: 'Activa tu Energía Femenina y Manifiesta la Vida que Anhelas. Programa de 21 días de transformación emocional, gratitud y productividad. Incluye audios, ebook y ejercicios prácticos. Promo 50% de Descuento $19.99.'
    }, {
      name: 'keywords',
      content: 'energía femenina, manifestación, amor propio, relaciones conscientes, abundancia, reprogramación subconsciente, alma en expansión, danielle e. s., programa 21 días, magnetismo femenino, sanar heridas'
    }, {
      name: 'author',
      content: 'Danielle E. S. - Alma en Expansión'
    }, {
      name: 'robots',
      content: 'index, follow'
    },
    // Open Graph (Facebook, WhatsApp, Instagram)
    {
      property: 'og:title',
      content: 'Activa tu Energía Femenina | Alma en Expansión'
    }, {
      property: 'og:description',
      content: 'Programa de 21 días para activar tu energía femenina, recuperar tu poder y manifestar la vida que anhelas. Incluye audios, ebook y bonos exclusivos.'
    }, {
      property: 'og:type',
      content: 'product'
    }, {
      property: 'og:image',
      content: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png'
    }, {
      property: 'og:locale',
      content: 'es_ES'
    }, {
      property: 'og:site_name',
      content: 'Alma en Expansión'
    }, {
      property: 'product:price:amount',
      content: '19.99'
    }, {
      property: 'product:price:currency',
      content: 'USD'
    },
    // Twitter Card
    {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: 'Activa tu Energía Femenina | Alma en Expansión'
    }, {
      name: 'twitter:description',
      content: 'Programa de 21 días para activar tu energía femenina y manifestar abundancia. Promo 50% de Descuento $19.99.'
    }, {
      name: 'twitter:image',
      content: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png'
    }];
    metaTags.forEach(({
      property,
      name,
      content
    }: any) => {
      const selector = property ? `meta[property="${property}"]` : `meta[name="${name}"]`;
      let meta = document.querySelector(selector) as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        if (property) meta.setAttribute('property', property);
        if (name) meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });
    // Add JSON-LD structured data for SEO
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (!existingScript) {
      const jsonLd = document.createElement('script');
      jsonLd.type = 'application/ld+json';
      jsonLd.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Activa tu Energía Femenina - Programa de 21 Días',
        description: 'Programa de transformación personal para activar tu energía femenina, recuperar tu valor emocional y atraer relaciones sanas. Incluye audio guiado, cuaderno de ejercicios y método paso a paso.',
        image: 'https://cdn.magicpatterns.com/uploads/qbJy231BvdXRV2UniJa3aM/hf_20260208_195520_c7bb8ee2-86fa-45c1-8c00-3f3dd3334691.png',
        brand: {
          '@type': 'Brand',
          name: 'Alma en Expansión'
        },
        author: {
          '@type': 'Person',
          name: 'Danielle E. S.'
        },
        offers: {
          '@type': 'Offer',
          price: '19.99',
          priceCurrency: 'USD',
          availability: 'https://schema.org/InStock',
          url: 'https://almaenexpansion.com/products/activa-tu-energia-femenina'
        },
        aggregateRating: {
          '@type': 'AggregateRating',
          ratingValue: '5',
          reviewCount: '412'
        }
      });
      document.head.appendChild(jsonLd);
    }
  }, []);
  return <LandingPage data-id="element-0" />;
}